export enum AccountType
{
    Swedish,
    Iban,
    OtherInternational,
    Plusgiro,
    Bankgiro
}